import { useEffect, useState } from "react";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "../firebase";
import { toast } from "sonner";

// Export this so it can be used elsewhere (like Login)
export const fetchToken = async () => {
    try {
        if (typeof window !== "undefined" && "serviceWorker" in navigator) {
            let permission = Notification.permission;
            if (permission !== "granted") {
                permission = await Notification.requestPermission();
            }

            if (permission === "granted") {
                const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

                // Get the existing service worker registration
                const registration = await navigator.serviceWorker.ready;

                const currentToken = await getToken(messaging, {
                    vapidKey: vapidKey,
                    serviceWorkerRegistration: registration,
                });
                if (currentToken) {
                    return currentToken;
                } else {
                    console.error(
                        "No registration token available. Request permission to generate one."
                    );
                }
            } else {
                console.error("Notification permission denied");
            }
        }
    } catch (error) {
        console.error("An error occurred while retrieving token. ", error);
    }
    return null;
};

const useFcmToken = () => {
    const [token, setToken] = useState(null);
    const [notificationPermissionStatus, setNotificationPermissionStatus] =
        useState(Notification.permission);

    useEffect(() => {
        const retrieveToken = async () => {
            const currentToken = await fetchToken();
            setToken(currentToken);
            setNotificationPermissionStatus(Notification.permission);
        };

        retrieveToken();
    }, []);

    useEffect(() => {
        const unsubscribe = onMessage(messaging, (payload) => {
            console.log("Foreground message received:", payload);

            // Play sound
            // Using a generic pleasant notification sound
            const audio = new Audio("/notification_tone.mp3");
            audio.play().catch((error) => console.error("Error playing sound:", error));

            // Show Slack-like toast
            toast(payload.notification.title, {
                description: payload.notification.body,
                icon: <img src="/logo192.png" alt="App Logo" style={{ width: 20, height: 20, borderRadius: '4px' }} />,
                action: {
                    label: "View",
                    onClick: () => console.log("Notification clicked"),
                },
                duration: 5000,
            });
        });

        return () => unsubscribe();
    }, []);

    return { token, notificationPermissionStatus };
};

export default useFcmToken;
